import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import EnhancedThemeProvider from 'components/EnhancedThemeProvider';
import CategoryForm from '../components/CategoryForm';

// GraphQL mutation for creating category
const CREATE_ANNUAL_TYPE = gql`
  mutation CreateAnnualType($input: CreateAnnualTypeInput!) {
    createAnnualType(input: $input) {
      id
      name
      account {
        id
        business_dba
      }
    }
  }
`;

const AddCategoryContent = () => {
  const history = useHistory();
  const location = useLocation();
  const [saving, setSaving] = useState(false);

  // Get account_id from URL params
  const searchParams = new URLSearchParams(location.search);
  const accountId = searchParams.get('account_id');

  // Determine route prefix for navigation
  const { pathname } = location;
  const isTrackAdmin = pathname?.includes('admin-track');
  const isEmployeeAdmin = pathname?.includes('admin-employee');
  const routePrefix = isTrackAdmin
    ? '/admin-track'
    : isEmployeeAdmin
    ? '/admin-employee'
    : '/admin';

  // Mutation
  const [createAnnualType] = useMutation(CREATE_ANNUAL_TYPE);

  const handleSubmit = async (formData) => {
    setSaving(true);

    try {
      const { data } = await createAnnualType({
        variables: {
          input: formData,
        },
      });

      if (data?.createAnnualType) {
        // Navigate back to categories list with success state
        const redirectUrl = accountId
          ? `${routePrefix}/annualcategories?account_id=${accountId}`
          : `${routePrefix}/annualcategories`;

        history.push(redirectUrl, {
          toaster: {
            type: 'success',
            title: 'Success!',
            message: 'Category created successfully.',
          },
        });
      }
    } catch (error) {
      setSaving(false);
      throw error;
    }
  };

  const handleCancel = () => {
    const backUrl = accountId
      ? `${routePrefix}/annualcategories?account_id=${accountId}`
      : `${routePrefix}/annualcategories`;
    history.push(backUrl);
  };

  return (
    <CategoryForm
      mode="add"
      initialData={null}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      saving={saving}
      accountId={accountId}
    />
  );
};

// Wrap with theme provider
const AddCategory = () => (
  <EnhancedThemeProvider>
    <AddCategoryContent />
  </EnhancedThemeProvider>
);

export default AddCategory;
